export const LOCALE_PREFIX = 'components.GoogleMap'

export const GOOGLE_MAP_INIT = 'GOOGLE_MAP_INIT'
export const GOOGLE_MAP_CLOSE = 'GOOGLE_MAP_CLOSE'
export const GOOGLE_MAP_ZOOM_CHANGE = 'GOOGLE_MAP_ZOOM_CHANGE'
export const GOOGLE_MAP_CHANGE_URL = 'GOOGLE_MAP_CHANGE_URL'
export const GOOGLE_MAP_CHECKBOX_CHANGE = 'GOOGLE_MAP_CHECKBOX_CHANGE'
export const GOOGLE_MAP_CHANGE_SATELLITE_VIEW = 'GOOGLE_MAP_CHANGE_SATELLITE_VIEW'
export const GOOGLE_MAP_CHANGE_STREETVIEW_URL = 'GOOGLE_MAP_CHANGE_STREETVIEW_URL'
export const GOOGLE_MAP_TOGGLE_STREETVIEW_EXPAND = 'GOOGLE_MAP_TOGGLE_STREETVIEW_EXPAND'
export const GOOGLE_MAP_TOGGLE_COLLAPSED = 'GOOGLE_MAP_TOGGLE_COLLAPSED'

export const ADDRESS_TYPES = {
    ADA001: 'registered',
    ADA006: 'shops',
    ADA0RP: 'branch',
}

export const TYPE_COLORS = {
    ADA001: 'red',
    ADA006: 'yellow',
    ADA0RP: 'green',
}
